import { QueryClient } from 'react-query';
import api from './apiUtils';


const queryClient = new QueryClient();
// All defualt query API goes here
api.get('/');
// All default mutation API goes here

export default queryClient;